export class Fluke {
  constructor (opts) {
    this.handler = opts.handler
    this.scanner = opts.scanner
    this.options = opts.options
    this.derivable = !!opts.derivable
  }
}



// WEBPACK FOOTER //
// ./src/fluke.js